import type IThrottleObserver from '@/utils/typescript/IThrottleObserver';

type Callback<T = any> = (...args: any[]) => T; // eslint-disable-line @typescript-eslint/no-explicit-any

/**
 * throttle function allows to control function execution timing.
 * For example you could set a throttle on a function that could be used
 * to resize an element inside a loop event like camera position resize element or else.
 * Function will ensure that the callback is executed only once in the given time frame.
 * @param { function } callback callback function to execute on time out
 * @param { number } time timing of the setTimeout -> milliseconds
 * @param { Object } objectBoolObserver booleand used to safe guard the callback execution
 * @returns { null }
 */
const throttle =
    <T>(callback: Callback<T>, time: number, objectBoolObserver: IThrottleObserver) =>
    () => {
        if (objectBoolObserver.throttleTimer) return;
        objectBoolObserver.throttleTimer = true;
        setTimeout(() => {
            callback();
            objectBoolObserver.throttleTimer = false;
        }, time);
    };

// eslint-disable-next-line import/prefer-default-export
export { throttle };
